import type {
  CashierPerformance, InventoryValuation, ProductPerformance, ProfitAndLoss,
  ReportRange, SalesSummary, SeriesPoint, StagnantProduct,
} from '@najah/core'
import { fetchAndSave } from './download'
import { api, getAccessTokenForDownload } from './api'

export interface TaxReport {
  brackets: { taxRate: number; taxableAmount: number; taxAmount: number; invoiceCount: number }[]
  totalTaxable: number
  totalTax: number
}

export interface PurchasesSummary {
  purchaseCount: number
  purchaseTotal: number
  shippingTotal: number
  paidToSuppliers: number
}

export interface DashboardData {
  today: SalesSummary
  month: SalesSummary
  series: SeriesPoint[]
  topProducts: ProductPerformance[]
  valuation: InventoryValuation
  profitAndLoss: ProfitAndLoss
  alerts: { pendingOrders: number; lowStock: number; supplierDebt: number }
}

type RangeQuery = Partial<ReportRange> & Record<string, string | number | undefined>

export const reportsApi = {
  dashboard: () => api<DashboardData>('/reports/dashboard'),
  summary: (range: RangeQuery) => api<SalesSummary>('/reports/sales/summary', { query: range }),
  series: (range: RangeQuery) => api<SeriesPoint[]>('/reports/sales/series', { query: range }),
  products: (range: RangeQuery) => api<ProductPerformance[]>('/reports/sales/products', { query: range }),
  cashiers: (range: RangeQuery) => api<CashierPerformance[]>('/reports/sales/cashiers', { query: range }),
  stagnant: (days: number) => api<StagnantProduct[]>('/reports/inventory/stagnant', { query: { days } }),
  valuation: () => api<InventoryValuation>('/reports/inventory/valuation'),
  profitLoss: (range: RangeQuery) => api<ProfitAndLoss>('/reports/profit-loss', { query: range }),
  purchases: (range: RangeQuery) => api<PurchasesSummary>('/reports/purchases/summary', { query: range }),
  tax: (range: RangeQuery) => api<TaxReport>('/reports/tax', { query: range }),
}

const BASE_URL = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000'

/** تنزيل CSV — عبر saveFile ليعمل في المتصفّح وفي نافذة Tauri معاً */
export async function downloadReport(
  report: 'products' | 'cashiers' | 'stagnant' | 'series' | 'tax',
  range: RangeQuery,
): Promise<'saved' | 'cancelled'> {
  const url = new URL(`${BASE_URL}/api/reports/export`)
  url.searchParams.set('report', report)
  for (const [k, v] of Object.entries(range)) {
    if (v !== undefined && v !== '') url.searchParams.set(k, String(v))
  }

  return fetchAndSave(url, getAccessTokenForDownload(), `najah-${report}-${new Date().toISOString().slice(0, 10)}.csv`)
}
